import type { FC } from 'react';
import DefaultLayout from './layouts/DefaultLayout';
import SelectedLayout from './layouts/SelectedLayout';
import GallectionLayout from './layouts/GallectionLayout';
import TierLayout from './layouts/TierLayout';
import { StudioSection } from '../../types/store';

export interface Props {
  activeSection: StudioSection;
  publishedFolderId?: number;
  publishedTierId?: number;
  selectedCount?: number;
  allIsSelected?: boolean;
  onSelectAll?: (isSelected: boolean) => void;
}

const StudioHeaderMobile: FC<Props> = ({
  activeSection,
  publishedFolderId,
  publishedTierId,
  selectedCount = 0,
  allIsSelected,
  onSelectAll,
}) => {
  const isStashSection = activeSection === StudioSection.STASH;
  const isPublishedSection = activeSection === StudioSection.PUBLISHED;

  const hasSelection = selectedCount > 0;
  if (hasSelection) {
    return (
      <SelectedLayout
        activeSection={activeSection}
        selectedCount={selectedCount}
        allIsSelected={allIsSelected}
        onSelectAll={onSelectAll}
      />
    );
  }

  if (isStashSection || (isPublishedSection && publishedFolderId)) {
    return <GallectionLayout />;
  }
  if (isPublishedSection && publishedTierId) {
    return <TierLayout />;
  }

  return <DefaultLayout />;
};
StudioHeaderMobile.displayName = 'StudioHeaderMobile';

export default StudioHeaderMobile;
